import CustomTabs from '@/components/desktop/CustomTabs';
import SearchFlightTab from '@/containers/Desktop/SearchFlightTabVcms';
import SearchBusTab from '@/containers/Bus/SearchBusTab/desktop';
import SearchTrainTab from '@/containers/SearchTrainTab/desktop';
import FlightIcon from '@mui/icons-material/Flight';
import { Box } from '@mui/material';
import TrainIcon from '@mui/icons-material/Train';
import { styled } from '@mui/system';
import { useDispatch } from 'react-redux';
import { setCalendarType } from '@/slices/calendar/calendarSlice';
import { FC } from 'react';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';

const Container = styled(Box)`
  position: relative;
`;

interface LandingPageProps {
  title?: string;
  titleComponent?: string;
  filterAirline?: any
  onSearchClick?: () => void;
  lang?: ILangObj;
  isFirstTime?: boolean;
  startPoint: any,
  toPoint: any,
  switchUpdateSecondTime: any;
  statePassenger: any;
  stateSeatClass: any;
  isTrain?: boolean;
}

const LandingPageVcms: FC<LandingPageProps> = ({
  title, titleComponent, filterAirline, onSearchClick, lang, isFirstTime, startPoint, toPoint, switchUpdateSecondTime, statePassenger,
  stateSeatClass, isTrain,
}) => {
  const dispatch = useDispatch();

  return (
    <Container sx={{
      height: {
        xs: '400px',
        lg: '220px',
      },
    }}
    >
      <CustomTabs
        isTrain={isTrain}
        lang={lang}
        seoStyle
        onClickTab={(newTab: string) => {
          dispatch(setCalendarType({ calendarType: newTab as any }));
        }}
        labelObjs={[
          {
            type: isTrain ? 'train' : 'flight',
            icon: <div style={{ transform: !isTrain ? 'translateX(25%) rotate(45deg) translateY(25%)' : 'translateX(0) rotate(0) translateY(7px)' }}>{isTrain ? <TrainIcon /> : <FlightIcon />}</div>,
          },
        ]}
        tabComponent={[<SearchFlightTab
          isTrain={isTrain}
          // filterAirline={filterAirline}
          onSearchClick={onSearchClick}
          key={1}
          isVcms
          lang={lang}
          isFirstTime={isFirstTime}
          startPoint={startPoint}
          toPoint={toPoint}
          switchUpdateSecondTime={switchUpdateSecondTime}
          statePassenger={statePassenger}
          stateSeatClass={stateSeatClass}
        />, <SearchBusTab
          key={2}
        />, <SearchTrainTab
          key={3}
        />]}
      />
    </Container>
  );
};
export default LandingPageVcms;
